import styled from "styled-components";

export const PopupButton = styled.button`
  background-color: rgb(10 ,92 ,86);
  border: none;
  cursor: pointer;
  font-weight: bold;
  color: white;
  text-align: center;
  font-size: 1rem;
  border-radius: 10px;
  padding: 0.8rem;
  width: 100%;

  &:hover{
  background-color: rgba(59, 59, 59, 0.86);
  }
`;
export const Title = styled.h2`
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: rgb(10 ,92, 86);
  margin-top: 0;
`;
export const AccountPopup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
  background: white;
  border-radius: 10px;
  padding: 2rem 1.5rem;
  width: 90%;
  max-width: 450px;   /* prevent it from being too wide */
  direction: rtl;
  text-align: center;
  position: relative;

  div {
    width: 100%;
  }

  @media (min-width: 768px) {
    padding: 2.5rem 3rem;
    width: 70%;
  }

  @media (min-width: 1200px) {
    width: 40%;
  }
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  padding: 0.75rem;
  border: 2px solid ${({ hasError }) => (hasError ? "red" : " rgb(10, 92 ,86)")};
  border-radius: 10px;
  text-align: center;
  outline: none;
  margin: 0.5rem auto;
`;

export const AddPhoto = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  p{
    font-size: 12px;
    font-weight: bold;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const PhotoLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: #f0f0f0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  border: 1px solid #ccc;
  transition: background 0.3s;

  &:hover {
    background-color: #e0e0e0;
  }

  p {
    font-size: 12px;
    font-weight: bold;
    margin: 0;
  }
`;
export const ErrorMsg=styled.p`
color: red;
font-size: 10px;
`